var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"AudioButton",on:{"click":_vm.play}},[_c('CategoryImage',{attrs:{"src":"/img/categories/note/notes.png","alt":"note"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }